/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import type * as React from 'react';

import {ToastEl} from 'common/components/toast/panel';
import {formatTextReact} from 'common/util/format-text-react';

import type {ToastArea} from './index';

export function template(this: ToastArea) {
  const {toasts} = this.state;

  return (
    <div sel='.mp-toast-area'>
      {toasts.map((toast) => {
        const resolvedMessage =
          typeof toast.message === `function` ? this.getContext(`i18n`).print(toast.message) : toast.message;
        const messageNode =
          typeof resolvedMessage === `string`
            ? formatTextReact(resolvedMessage)
            : (resolvedMessage as unknown as React.ReactNode);
        return (
          <ToastEl
            cta={toast.cta || ``}
            ctaHref={toast.ctaHref || ``}
            ctaTarget={toast.ctaTarget || ``}
            elref={toast.elref || `toast${toast.id}`}
            hide={toast.hide}
            hideCancelButton={toast.hideCancelButton}
            undoable={toast.undoable}
            undoLabel={toast.undoLabel || `Undo`}
            timeout={toast.isStatic ? null : toast.timeout}
            type={toast.type}
            message={messageNode}
            onAction={() => this.helpers.toastAction(toast)}
            onClose={() => this.helpers.toastClose(toast)}
            onUndo={() => this.helpers.toastUndo(toast)}
          />
        );
      })}
    </div>
  );
}
